import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';

import backstageImg from './img/backstage-img.avif';
import css from './CreatorsPage.module.css';

const SectionBackstage = () => {
  return (
    <div className={css.sectionBackstage}>
      <div className={css.backstageImgContainer}>
        <h3 className={css.backstageImgTitle}>Cast & Crew</h3>
        <img className={css.backstageImg} alt="Performing" src={backstageImg} />
      </div>
      <div className={css.backstageContent}>
        <h2 className={css.backstageTitle}>
          <FormattedMessage id="CreatorsPage.backstageTitle" />
        </h2>
        <p className={css.backstageText}>
          <FormattedMessage
            id="CreatorsPage.backstageText"
            values={{
              textBreak: <br />,
            }}
          />
        </p>
      </div>
    </div>
  );
};

export default SectionBackstage;
